import { PortalError } from './PortalError';

export class AffectedRecordsError extends PortalError {
  constructor(affected: number, expected: number) {
    super('AffectedRecordsError', `Not all affected records were updated: ${affected}/${expected}`);
  }
}
